import keys from "./keys.js";
export default function createEscaper(map) {
  var escaper = function(match) {
    return map[match];
  };
  var source = "(?:" + keys(map).join("|") + ")";
  var testRegexp = RegExp(source);
  var replaceRegexp = RegExp(source, "g");
  return function(string) {
    string = string == null ? "" : "" + string;
    return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
  };
}
